import { HttpParams } from '@angular/common/http';
import { AfterViewChecked, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NbStepperComponent } from '@nebular/theme';
import { ToastService } from '../../@theme/service/toast.service';
import { DownloadService } from '../../common/service/download.service';
import { ReleaseService } from '../../common/service/release.service';

@Component({
  selector: 'ngx-content-release',
  templateUrl: './content-release.component.html',
  styleUrls: ['./content-release.component.scss'],
})
export class ContentReleaseComponent implements OnInit, AfterViewChecked {

  @ViewChild('stepper', { static: false })
  stepperComponent: NbStepperComponent;

  @ViewChild('inputStep1', { static: false }) inputStep1!: ElementRef;
  @ViewChild('inputStep2', { static: false }) inputStep2: ElementRef;

  step1: FormGroup; // Email
  step2: FormGroup; // Token

  public data: any;
  public isRequesting = false;
  public isLast = false;
  public contentItems: any[] = [];

  constructor(
    private fb: FormBuilder,
    private changeDetector: ChangeDetectorRef,
    private downloadService: DownloadService,
    private toast: ToastService,
    private releaseService: ReleaseService,
  ) {
  }
  
  ngOnInit() {
    this.step1 = this.fb.group({
      email: ['', Validators.required],
    });
    this.step2 = this.fb.group({
      token: ['', Validators.required],
    });
  }

  ngAfterViewChecked(): void {
    if (!this.isLast && this.isRequesting)
    this.inputStep1.nativeElement.focus();
  }

  contentCheck() {
    const params = new HttpParams()
      .set('email', this.step1.get('email').value)
      .set('token', this.step2.get('token').value);

    this.releaseService.contentCheck(params).subscribe(res => {
      if (res && res.result) {
        if (res.data)
          this.contentItems = res.data;
        this.isLast = true;
      } else {
        this.toast.showToast('warning', res.message);
        this.isLast = false;
      }
    }, err => {
      console.error(err);
      this.isLast = false;
      this.toast.showToast('danger', 'i-SCAN 연결 확인중 알 수 없는 오류 발생.')
    });
  }

  download(fileName: string) {
    if (!confirm(`${fileName}을 다운로드 하겠습니까?`)) return;

    const params = new HttpParams()
      .set('email', this.step1.get('email').value)
      .set('token', this.step2.get('token').value)
      .set('fileName', fileName);

    this.downloadService.downloadContent(params).subscribe((blob: Blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
      this.toast.showToast('success', '다운로드 성공.');
    }, err => {
      console.error(err);
      this.toast.showToast('danger', '오류발생', '파일을 받을 수 없습니다.');
    });
  }

  onStepSubmit(setp: number) {
    switch (setp) {
      case 1:
        this.step1.markAsDirty();
        const email = this.step1.get('email').value;
        if (!email) {
          this.toast.showToast(
            'warning',
            '담당자의 이메일주소를 입력해 주세요.',
            '',
          );
          this.inputStep1.nativeElement.focus();
          return;
        }
        this.stepperComponent.next();
        this.changeDetector.detectChanges();
        this.inputStep2.nativeElement.focus();
        break;
      case 2:
        this.step2.markAsDirty();
        const token = this.step2.get('token').value;
        if (!token) {
          this.toast.showToast(
            'warning',
            '토큰을 입력해 주세요.',
            '',
          );
          this.inputStep2.nativeElement.focus();
          return;
        }
        this.contentCheck();
        break;
    }
  }

  prev(currentStep: number) {
    switch (currentStep) {
      case 2:
        setTimeout(()=> {
          this.step1.markAsPristine();
          this.inputStep1.nativeElement.focus();
        }, 100);
        break;
    }

    this.stepperComponent.previous();
  }

  toggleRequest() {
    this.isRequesting = !this.isRequesting;
  }
}
